export default "__VITE_ASSET__DpgkXUj8__"